import { Component } from "react";
import * as Scrivito from "scrivito";
import Slider from "react-slick";
import { isLiv } from "^/utils/isLiv";
import InPlaceEditingPlaceholder from "../../Components/InPlaceEditingPlaceholder";

class GalleryWidget extends Component {
  slider = null;

  stopSlider = () => {
    if (this.slider) {
      this.slider.slickPause();
    }
  };

  startSlider = () => {
    if (this.slider) {
      this.slider.slickPlay();
    }
  };

  render() {
    const { widget } = this.props;
    const images = widget.get("images");
    const sliderDotsDesc = widget.get("dotsDescription") || "Foliennummer";

    if (!images.length) {
      return (
        <InPlaceEditingPlaceholder center>
          Select images in the widget properties.
        </InPlaceEditingPlaceholder>
      );
    }

    const settings = {
      arrows: false,
      autoplay: true,
      autoplaySpeed: 7000,
      centerMode: true,
      centerPadding: "0px",
      cssEase: "linear",
      dots: true,
      ref: (slider) => {
        this.slider = slider;
      },
      // fade: true does not play well with prerendering. See [1] for details
      // [1] https://github.com/akiran/react-slick/issues/1343
      fade: false,
      infinite: true,
      slide: "li",
      slidesToShow: 1,
      speed: 500,
      variableWidth: false,
      responsive: [
        {
          breakpoint: 800,
          settings: {
            centerMode: false,
          },
        },
      ],
      appendDots: (dots) => <ul>{dots}</ul>,
      customPaging: (i) => <button aria-label={`${sliderDotsDesc} ${i + 1}`} />,
    };

    const bgColor = isLiv(Scrivito.currentPage()) ? "bg-teal" : "bg-blue";

    return (
      <div
        className="slick-gallary-fluid"
        onFocus={() => this.stopSlider()}
        onBlur={() => this.startSlider()}
        onMouseEnter={() => this.stopSlider()}
        onMouseLeave={() => this.startSlider()}
      >
        <Slider {...settings} className="slickslide">
          {images.map((image, index) => (
            <>
              <Scrivito.ImageTag
                content={image}
                key={`${image.id()}${index}`}
                alt={image.get("alternativeText")}
                loading="lazy"
                width={image?.metadata().get("width")}
                height={image?.metadata().get("height")}
                className="carousel-item-img"
              />
              {image.get("description") && (
                <div
                  className={`image-description p-2 ${bgColor}`}
                  dangerouslySetInnerHTML={{ __html: image.get("description") }}
                />
              )}
            </>
          ))}
        </Slider>
      </div>
    );
  }
}

Scrivito.provideComponent("GalleryWidget", GalleryWidget);
